<template>
  <div class="audit-demand">
    <div class="container">
      <tab
        :tabsValue="activeIndex"
        :tabPaneData="tabArr"
        @tabClick="handleTab"
        style="margin-bottom: 20px"
      />
      <e-search
        :count="100"
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
        style="margin-bottom: 20px"
      ></e-search>
    </div>
    <div class="container">
      <e-table-list
        :index-show="true"
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        :reserve-selection="false"
      >
        <template #operate="slot">
          <eui-btn
            type="link"
            class="blue-box"
            size="20"
            @click="handlePlan('1', slot.scope.row.purchaseDemandId)"
            v-if="activeIndex == 0"
          >
            审批
          </eui-btn>
          <eui-btn
            type="link"
            size="20"
            class="blue-box"
            @click="handlePlan('2', slot.scope.row.purchaseDemandId)"
          >
            查看详情
          </eui-btn>
        </template>
      </e-table-list>
      <el-pagination
        style="margin-top: 20px"
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="queryData.pageNum"
        :total="queryData.pageTotal"
        :page-size.sync="queryData.pageSize"
        prev-text="上一页"
        next-text="下一页"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import eSearch from '@/modules/projectA/components/common/e-search.vue';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import Tab from '@/modules/projectA/components/common/e-tabs.vue';
import Api from '@/modules/projectA/api/auditManagement/index';

export default {
  name: 'DemandAudit',
  components: { eSearch, eTableList, Tab },
  data() {
    return {
      activeIndex: '0',
      tabArr: [
        {
          label: '待审批',
          id: '0',
        },
        {
          label: '已审批',
          id: '1',
        },
      ],
      loading: false,
      filterInfo: {
        data: {
          purchaseDemandName: '',
          purchaseDemandCode: '',
          submitTime: '',
        },
        fieldList: [
          { label: '需求计划名称', type: 'input', value: 'purchaseDemandName' },
          { label: '需求计划编号', type: 'input', value: 'purchaseDemandCode' },
          {
            label: '提交日期',
            type: 'date',
            value: 'submitTime',
            dateType: 'daterange',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            defaultTime: ['00:00:00', '23:59:59'],
          },
          // {label: "状态", type: "select", value: "", list: 'statusList'},
        ],
        /**配置项 */
        btnStyle: [{ text: '查询', type: 'primary' }, { text: '重置' }],
      },
      listTypeInfo: {
        statusList: [
          { name: '全部', id: null },
          { name: '新建', id: 1 },
          { name: '待审核', id: 2 },
          { name: '审核通过', id: 3 },
          { name: '驳回', id: 4 },
        ],
      },
      tableData: [],
      tableLabel: [
        {
          label: '需求计划编号',
          param: 'purchaseDemandCode',
          align: 'center',
          width: '180',
        },
        { label: '需求计划名称', param: 'purchaseDemandName', align: 'center' },
        { label: '提交日期', param: 'submitTime', align: 'center' },
        { label: '需求申请人', param: 'createMemberName', align: 'center' },
        {
          label: '状态',
          param: '',
          align: 'center',
          render: (row) => {
            if (row.auditStatus == 0) {
              return '待审批';
            } else if (row.auditStatus == 1) {
              return '审批通过';
            } else if (row.auditStatus == 2) {
              return '审批拒绝';
            }
          },
        },
        { label: '操作', align: 'center', slot: 'operate' },
      ],
      queryData: {
        purchaseDemandName: '',
        purchaseDemandCode: '',
        submitTime: '',
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    };
  },
  methods: {
    handlePlan(flag, purchaseDemandId) {
      this.$router.push({
        path: '/auditManagement/demand/demandDetail',
        query: { flag: flag, purchaseDemandId: purchaseDemandId },
      });
    },
    handleTab(row) {
      this.queryData = {
        purchaseDemandName: '',
        purchaseDemandCode: '',
        submitTime: '',
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      };
      this.activeIndex = row.name;
      if (this.activeIndex == '1') {
        this.queryDemandApprovedPage();
      } else {
        this.queryDemandAuditPage();
      }
    },
    async queryDemandApprovedPage() {
      let res = await Api.queryDemandApprovedPage(this.queryData);
      if (res.code == '200') {
        this.tableData = res.data.records || [];
        this.queryData.pageTotal = res.data.total || 0;
      }
    },
    handleReset() {
      this.queryData = {
        purchaseDemandName: '',
        purchaseDemandCode: '',
        submitTime: '',
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      };
      if (this.activeIndex == '1') {
        this.queryDemandApprovedPage();
      } else {
        this.queryDemandAuditPage();
      }
    },
    handleFilter(val) {
      this.queryData.purchaseDemandName = val.purchaseDemandName
        ? val.purchaseDemandName
        : null;
      this.queryData.purchaseDemandCode = val.purchaseDemandCode
        ? val.purchaseDemandCode
        : null;
      this.queryData.submitTimeStart =
        val.submitTime && val.submitTime.length > 0 ? val.submitTime[0] : null;
      this.queryData.submitTimeEnd =
        val.submitTime && val.submitTime.length > 0 ? val.submitTime[1] : null;
      this.queryData.pageNum = 1;
      if (this.activeIndex == '1') {
        this.queryDemandApprovedPage();
      } else {
        this.queryDemandAuditPage();
      }
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      if (this.activeIndex == '1') {
        this.queryDemandApprovedPage();
      } else {
        this.queryDemandAuditPage();
      }
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      if (this.activeIndex == '1') {
        this.queryDemandApprovedPage();
      } else {
        this.queryDemandAuditPage();
      }
    },
    async queryDemandAuditPage() {
      let res = await Api.queryDemandAuditPage(this.queryData);
      if (res.code == '200') {
        this.tableData = res.data.records || [];
        this.queryData.pageTotal = res.data.total || 0;
      }
    },
  },
  mounted() {
    this.queryDemandAuditPage();
  },
};
</script>

<style scoped lang="scss">
.audit-demand {
  // background: #fff;
}
.blue-box {
  color: #2f80ed;
  cursor: pointer;
  &:hover {
    border-bottom: 1px solid #2f80ed;
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
}
</style>
